const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID || 'tfes9lvj0s';

export function initializeClarity() {
  if (typeof window === 'undefined') return;

  // Only run in production builds
  if (process.env.NODE_ENV !== 'production') return;

  const host = window.location.hostname;

  // Only allow the real production hosts
  const allowedHosts = [
    'www.kranawettertransport.com',
    'kranawettertransport.com',
  ];

  // Optional feature flag to turn Clarity on/off without code changes
  const enabledFlag = process.env.REACT_APP_ENABLE_CLARITY;
  if (enabledFlag && enabledFlag !== 'true') return;

  if (!allowedHosts.includes(host)) return;

  // Avoid double-injecting Clarity
  if (window.clarity && typeof window.clarity === 'function') return;

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', CLARITY_PROJECT_ID);
}

